/**
 * Visual-only overrides for the Pumper Bundles app block.
 *
 * The app renders its own DOM client-side and may set inline styles or
 * re-render after our stylesheet has already applied, so CSS alone doesn't
 * always win. This re-applies a small set of presentation properties as
 * inline styles (highest specificity short of !important on the element
 * itself) and re-runs whenever the app block's DOM changes.
 *
 * Strictly presentational: only style.setProperty() calls below. No event
 * listeners, no form/data-attribute access, no interaction with cart,
 * variant, or bundle-selection logic — the app's own behavior is untouched.
 *
 * Selectors are best-guess attribute matches until real class names are
 * captured from the rendered page (DevTools -> right-click the card ->
 * Inspect -> Copy -> Copy outerHTML). Replace the selectors inside
 * applyOverrides() once that HTML is available.
 */
(function () {
  /*
   * Pumper's own markup only. `.shopify-app-block` used to be in here, but
   * that is the wrapper Shopify puts around EVERY app block — so this also
   * captured the Kaching Bundles widget, where every class is named
   * `kaching-bundles__*` and therefore matched the `[class*="bundle"]` rule
   * below. That stamped `border-radius: 20px !important` inline onto every
   * node in that widget, and an inline `!important` outranks every author
   * stylesheet — so it also made Kaching's own radius setting and its
   * custom-CSS field unable to change the radius at all.
   */
  const SCOPE_SELECTOR = '[class*="pumper" i], [id*="pumper" i], [class*="pmpr" i], [id*="pmpr" i]';

  function applyOverrides(root) {
    if (root.closest('[class*="kaching" i]')) return;
    root.querySelectorAll('[class*="card" i], [class*="bundle" i]').forEach((el) => {
      el.style.setProperty('border-radius', '20px', 'important');
    });

    root.querySelectorAll('[class*="badge" i], [class*="ribbon" i], [class*="save" i]').forEach((el) => {
      el.style.setProperty('border-radius', '6px', 'important');
      el.style.setProperty('font-weight', '600', 'important');
    });

    root.querySelectorAll('[class*="subtitle" i], [class*="subtext" i], [class*="description" i]').forEach((el) => {
      el.style.setProperty('font-weight', '400', 'important');
    });

    root.querySelectorAll('[class*="shipping" i]').forEach((el) => {
      el.style.setProperty('font-weight', '400', 'important');
    });
  }

  function init() {
    const roots = document.querySelectorAll(SCOPE_SELECTOR);
    if (!roots.length) return;

    roots.forEach((root) => {
      applyOverrides(root);

      const observer = new MutationObserver(() => applyOverrides(root));
      observer.observe(root, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
